/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationSlotTime200Response
 */
export interface GetReservationSlotTime200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationSlotTime200Response
     */
    slotTime: GetReservationSlotTime200ResponseSlotTimeEnum;
}


/**
 * @export
 */
export const GetReservationSlotTime200ResponseSlotTimeEnum = {
    NUMBER_15: 15,
    NUMBER_30: 30,
    NUMBER_45: 45,
    NUMBER_60: 60,
    NUMBER_90: 90,
    NUMBER_120: 120
} as const;
export type GetReservationSlotTime200ResponseSlotTimeEnum = typeof GetReservationSlotTime200ResponseSlotTimeEnum[keyof typeof GetReservationSlotTime200ResponseSlotTimeEnum];


/**
 * Check if a given object implements the GetReservationSlotTime200Response interface.
 */
export function instanceOfGetReservationSlotTime200Response(value: object): value is GetReservationSlotTime200Response {
    if (!('slotTime' in value) || value['slotTime'] === undefined) return false;
    return true;
}

export function GetReservationSlotTime200ResponseFromJSON(json: any): GetReservationSlotTime200Response {
    return GetReservationSlotTime200ResponseFromJSONTyped(json, false);
}

export function GetReservationSlotTime200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationSlotTime200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'slotTime': json['slotTime'],
    };
}

export function GetReservationSlotTime200ResponseToJSON(json: any): GetReservationSlotTime200Response {
    return GetReservationSlotTime200ResponseToJSONTyped(json, false);
}

export function GetReservationSlotTime200ResponseToJSONTyped(value?: GetReservationSlotTime200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slotTime': value['slotTime'],
    };
}

